import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, Card, CardBody } from 'reactstrap';

import { modelOf } from '../../../prop-types';
import AddressInfo from '../AddressInfo';
import Address from '../../../models/Address';
import globalTranslations from '../../../i18n/globalTranslations';

const DEFAULT_SHOW_ADDRESSES_COUNT = 5;

@observer
export class AddressList extends Component {
  state = {
    showAllAddresses: false
  };

  toggleShowAllAddresses = () => {
    this.setState((state) => ({
      showAllAddresses: !state.showAllAddresses
    }));
  };

  getFilteredAddresses = () => {
    const { addresses, filterString } = this.props;
    return addresses.filter((address) => {
      return (
        address.postal_code.includes(filterString) ||
        address.firstname.toLowerCase().includes(filterString) ||
        address.lastname.toLowerCase().includes(filterString) ||
        address.company.toLowerCase().includes(filterString) ||
        address.street_address.toLowerCase().includes(filterString) ||
        address.city.toLowerCase().includes(filterString) ||
        address.telephone.toLowerCase().includes(filterString)
      );
    });
  };

  renderAddressCard = (address) => {
    const { onRemoveClick, onEditClick } = this.props;

    return (
      <Card
        className="AddressList__item"
        key={address.id}
        color={address.is_primary ? 'info' : 'default'}
        outline
      >
        <CardBody>
          <ButtonGroup className="AddressList__item-buttons">
            <Button onClick={() => onEditClick(address.id)}>
              <FormattedMessage {...globalTranslations.editTitle} />
            </Button>
            <Button
              onClick={() =>
                window.confirm(
                  this.props.intl.formatMessage(
                    globalTranslations.confirmRemoveTitle
                  )
                ) && onRemoveClick(address.id)
              }
              color="danger"
            >
              <FormattedMessage {...globalTranslations.removeTitle} />
            </Button>
          </ButtonGroup>
          <AddressInfo address={address} />
          {address.is_primary && (
            <div className="AddressList__item-primary-notice">
              <FormattedMessage
                id="address.primaryNotice"
                defaultMessage="This address is used as your default delivery and billing address in your orders."
              />
            </div>
          )}
        </CardBody>
      </Card>
    );
  };

  render() {
    const filtered = this.getFilteredAddresses();
    const visibleAddresses = this.state.showAllAddresses
      ? filtered
      : filtered.slice(0, DEFAULT_SHOW_ADDRESSES_COUNT);

    return (
      <div className="AddressList">
        {visibleAddresses.map((address) => this.renderAddressCard(address))}
        {filtered.length > visibleAddresses.length && (
          <div className="AddressList__show-all-addresses">
            <Button onClick={this.toggleShowAllAddresses} color="primary">
              <FormattedMessage
                id="address.showAllAddressesButton"
                defaultMessage="Show all addresses"
              />
            </Button>
          </div>
        )}
      </div>
    );
  }
}

AddressList.propTypes = {
  addresses: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Address)),
    PropTypes.arrayOf(modelOf(Address))
  ]).isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  filterString: PropTypes.string,
  intl: intlShape.isRequired
};

AddressList.defaultProps = {
  filterString: ''
};

export default injectIntl(AddressList);



// WEBPACK FOOTER //
// ./src/components/address/AddressList/index.jsx